import { CalendarManagementActionsEnum, CalendarManagementViewEnum } from './types';
import { CustomMessage, UserRoleIDEnum } from '@alluradirect/react';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { EventTypeEnum } from '@alluradirect/react';
import { initialUIDashboardState } from './constants';

const dashboardUISlice = createSlice({
  name: 'dashboardUI',
  initialState: initialUIDashboardState,
  reducers: {
    setEventDrawerType: (state, { payload: { eventType } }: PayloadAction<{ eventType: EventTypeEnum }>) => {
      state.eventDrawer.type = eventType;
    },
    setBookingId: (state, { payload: { bookingId } }: PayloadAction<{ bookingId: number }>) => {
      state.calendarManagementDialog.bookingId = bookingId;
    },
    closeEventDrawer: state => {
      state.eventDrawer.isOpen = false;
      state.eventDrawer.type = null;
    },
    openEventDrawer: state => {
      state.eventDrawer.isOpen = true;
    },

    closeMessageGuestDialog: state => {
      state.messageGuestDialog.isOpen = false;
    },
    openMessageGuestDialog: (
      state,
      {
        payload: { bookingId, contactTypeId, contactId },
      }: PayloadAction<{ bookingId: number; contactTypeId: UserRoleIDEnum; contactId: number }>,
    ) => {
      state.messageGuestDialog = {
        data: { bookingId, contactId, contactTypeId },
        isOpen: true,
      };
    },
    openCalendarManagementDialog: state => {
      state.calendarManagementDialog.isOpen = true;
    },
    closeCalendarManagementDialog: state => {
      state.calendarManagementDialog.isOpen = false;
    },
    setCalendarManagementEditBooking: (state, { payload: { bookingId } }: PayloadAction<{ bookingId: number }>) => {
      state.calendarManagementDialog.bookingId = bookingId;
      state.calendarManagementDialog.isOpen = true;
      state.calendarManagementDialog.currentView = CalendarManagementViewEnum.editBookingWarning;
      state.calendarManagementDialog.action = CalendarManagementActionsEnum.editBooking;
    },
    setCalendarManagementCancelBooking: (state, { payload: { bookingId } }: PayloadAction<{ bookingId: number }>) => {
      state.calendarManagementDialog.bookingId = bookingId;
      state.calendarManagementDialog.isOpen = true;
      state.calendarManagementDialog.currentView = CalendarManagementViewEnum.cancelBooking;
      state.calendarManagementDialog.action = CalendarManagementActionsEnum.cancelBooking;
    },
    setCalendarManagementTransferBooking: (state, { payload: { bookingId } }: PayloadAction<{ bookingId: number }>) => {
      state.calendarManagementDialog.bookingId = bookingId;
      state.calendarManagementDialog.currentView = CalendarManagementViewEnum.transferBookingWarning;
      state.calendarManagementDialog.action = CalendarManagementActionsEnum.transferBooking;
    },
    setCalendarManagementView: (
      state,
      {
        payload: { currentView, activeStep },
      }: PayloadAction<{ currentView: CalendarManagementViewEnum; activeStep: number }>,
    ) => {
      state.calendarManagementDialog.currentView = currentView;
      state.calendarManagementDialog.activeStep = activeStep;
    },
    setCalendarManagementAction: (
      state,
      { payload: { action } }: PayloadAction<{ action: CalendarManagementActionsEnum }>,
    ) => {
      state.calendarManagementDialog.action = action;
    },
    setCalenderManagentPaymentInformation: (
      state,
      { payload: { paymentInformation } },
    ) => {
      state.calendarManagementDialog.paymentInformation = paymentInformation
    },
    reset: () => initialUIDashboardState,
    closeNotificationDrawer: state => {
      state.notificationDrawer.isOpen = false;
    },
    openNotificationDrawer: state => {
      state.notificationDrawer.isOpen = true;
    },
    toggleNavigationDrawer: state => {
      state.navDrawer.isOpen = !state.navDrawer.isOpen;
    },
    closeNavigationDrawer: state => {
      state.navDrawer.isOpen = false;
    },
    openCustomMessageDialog: (
      state,
      {
        payload: { bookingId, customMessage, bookingReference },
      }: PayloadAction<{ bookingId: number; customMessage: CustomMessage; bookingReference: string }>,
    ) => {
      state.customMessageDialog = {
        isOpen: true,
        bookingId,
        customMessage,
        bookingReference,
      };
    },
    closeCustomMessageDialog: state => {
      state.customMessageDialog = {
        isOpen: false,
        bookingId: 0,
        customMessage: { MESSAGE: '', ENTRY_CODE: '' },
        bookingReference: '',
      };
    },
    openRatesWizardDialog: state => {
      state.ratesWizardDialog.isOpen = true;
    },
    closeRatesWizardDialog: state => {
      state.ratesWizardDialog.isOpen = false;
    },
    openAvailabilityWizard: state => {
      state.availabilityWizard.isOpen = true;
    },
    closeAvailabilityWizard: state => {
      state.availabilityWizard.isOpen = false;
    },
    reRenderRateSchedule: state => {
      state.rateScheduleKey++;
    },
  },
});

export const {
  reducer: dashboardUIReducer,
  actions: {
    closeCalendarManagementDialog,
    closeEventDrawer,
    closeNavigationDrawer,
    closeNotificationDrawer,
    openCalendarManagementDialog,
    openEventDrawer,
    openNotificationDrawer,
    setCalendarManagementCancelBooking,
    setCalendarManagementTransferBooking,
    reset,
    setCalendarManagementAction,
    setCalenderManagentPaymentInformation,
    setCalendarManagementEditBooking,
    setCalendarManagementView,
    setEventDrawerType,
    toggleNavigationDrawer,
    openCustomMessageDialog,
    closeCustomMessageDialog,
    closeMessageGuestDialog,
    openMessageGuestDialog,
    setBookingId,
    closeRatesWizardDialog,
    openRatesWizardDialog,
    openAvailabilityWizard,
    closeAvailabilityWizard,
    reRenderRateSchedule,
  },
} = dashboardUISlice;
